import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import "./TimerDisplay.less";
import Background from "./Background";
import { ReactComponent as Cup } from '../../assets/images/pause-icon.svg';
import { applyTheme } from "../utils/themeUtils";

interface TimerDisplayProps {
    currentLevelIndex: number;
    timeLeft: number;
    levelDuration: number;
}

export default function TimerDisplay({ currentLevelIndex, timeLeft, levelDuration }: TimerDisplayProps) {
    const config = useSelector((state: RootState) => state.config.activeConfig);
    const theme = useSelector((state: RootState) => state.config.theme);

    const current = config?.blinds[currentLevelIndex];
    const next = config?.blinds[currentLevelIndex + 1];

    useEffect(() => {
        if (theme) {
            applyTheme(theme);
        }
    }, [theme]);

    if (!config || !current) {
        return (
            <div className="text-center text-white p-10">
                <p>Keine Config geladen oder keine Blindstruktur vorhanden.</p>
            </div>
        );
    }

    const formatTime = (seconds: number) => {
        const min = Math.floor(seconds / 60).toString().padStart(2, '0');
        const sec = (seconds % 60).toString().padStart(2, '0');
        return `${min}:${sec}`;
    };

    const progress = levelDuration > 0
        ? (levelDuration - timeLeft) / levelDuration
        : 0;

    return (
        <div className="timer-display">
            <div className="timer-box-wrapper">
                <Background className="inlay-bg" progress={progress} />

                <div className="timer-box-content">
                    <div className="time">{formatTime(timeLeft)}</div>

                    {current.type === 'break' ? (
                        <div className="pause flex items-center gap-2 justify-center">
                            <span>Pause</span> <Cup className="w-24 h-24" />
                        </div>
                    ) : (
                        <>
                            <div className="level-line">
                                <div className="line" />
                                <div className="label">Level {currentLevelIndex + 1}</div>
                                <div className="line" />
                            </div>

                            <div className="blinds">
                                <span className="blind">{current.smallBlind.toLocaleString('de-DE')}</span><span className="slashes">/</span>
                                <span className="blind">{current.bigBlind.toLocaleString('de-DE')}</span><span className="slashes">/</span>
                                <span className="slashes">{current.ante.toLocaleString('de-DE')}</span>
                            </div>
                        </>
                    )}
                </div>
            </div>


            <div className="bottom-display">
            {current.type !== 'break' && next && (
                <>
                    <div className="next-line">
                        <div className="line" />
                        <div className="label">Next</div>
                        <div className="line" />
                    </div>

                    <div className="next-wrapper">
                        <div className="next-blind">
                            {next.smallBlind.toLocaleString('de-DE')} / {next.bigBlind.toLocaleString('de-DE')}
                        </div>
                        <div className="next-ante">
                            <span><span className="next-ante-label">ANTE</span> {next.ante.toLocaleString('de-DE')}</span>
                        </div>
                    </div>
                </>
            )}
            </div>
        </div>
    );
}
